import { colors } from '../../Colors/colors'

export const templatesCoreTheme = {
   light: {
      markAsRequiredToggle: {
         titleColor: 'text-gray-700',
         descriptionColor: 'text-gray-600',
         infoIconColor: colors['gray-500']
      },
      markAsIdentifierToggle: {
         titleColor: 'text-gray-700',
         descriptionColor: 'text-gray-600',
         infoIconColor: colors['gray-500']
      },
      markAsDependentToggle: {
         titleColor: 'text-gray-700'
      },
      markAsUniqueToggle: {
         titleColor: 'text-gray-700',
         descriptionColor: 'text-gray-600',
         infoIconColor: colors['gray-500']
      },
      fieldType: {
         labelColor: 'text-gray-800',
         valueColor: 'text-gray-600',
         textInputIconColor: colors['gray-500'],
         rightArrowIconColor: colors['gray-500'],
         hoverBgColor: 'bg-gray-50'
      },
      tooltip: {
         backgroundColor: 'bg-gray-900'
      },
      sidePaneHeader: {
         statusTextColor: 'text-gray-600',
         statusIconColor: colors['gray-600']
      },
      fieldsSelectorOptions: {
         plusIconFillColor: colors['primary-600'],
         optionsTextColor: 'text-gray-900',
         collapsibleCardBorderColor: 'border-gray-300',
         closeIconFillColor: colors['gray-500'],
         dependentFieldTextColor: 'text-gray-600',
         alertCircleIconFillColor: colors['error-600'],
         optionsErrorTextColor: 'text-error-600',
         dotsMoveIconFillColor: colors['gray-500'],
         disabledPlusIconFillColor: colors['gray-300'],
         optionsSectionBGColor: 'bg-white'
      },
      recordCreationConfig: {
         common: {
            closeIconBGColor: colors['gray-500'],
            defaultBGColor: 'bg-white',
            defaultBorderColor: 'border-gray-300',
            defaultTextColor: 'text-gray-700',
            lineSeparatorBgColor: 'bg-gray-300'
         },
         configCard: {
            nameTextColor: 'text-gray-600',
            cardBgColor: 'bg-white',
            selectedBorderColor: 'border-primary-600',
            dividerBgColor: 'bg-gray-300'
         },
         configsList: {
            popoverTriggerHoverColor: 'hover:bg-gray-50',
            popoverTriggerIconColor: colors['gray-700'],
            popoverBorderColor: 'border-gray-200',
            trashIconColor: colors['error-600'],
            deleteTextColor: 'text-error-700',
            editIconColor: colors['gray-500'],
            renameTextColor: colors['gray-900'],
            hoverBgColor: 'hover:bg-gray-50',
            alertIconColor: colors['warning-600'],
            alertTextColor: 'text-warning-600',
            eyeIconColor: colors['gray-500'],
            eyeOffColor: colors['gray-300'],
            cardBgColor: 'bg-base-white',
            configNameTextColor: 'text-gray-800',
            roleBorderColor: 'border-gray-300',
            roleTextColor: 'text-gray-700'
         },
         configDetailedViewHeader: {
            chevronLeftIconFillColor: colors['gray-700'],
            bgColor: 'bg-base-white',
            borderColor: 'border-gray-300'
         },
         addOrEditConfig: {
            headerTextColor: 'text-gray-900',
            descriptionTextColor: 'text-gray-600'
         },
         configDetailedViewBody: {
            cardBgColor: 'bg-base-white',
            dividerBgColor: 'bg-gray-300',
            borderColor: 'border-gray-300',
            alertIconColor: colors['warning-600'],
            conditionPrefixTextColor: 'text-gray-600',
            conditionTextColor: 'text-gray-800'
         },
         configFieldsSelectionPane: {
            closeIconColor: colors['gray-500'],
            searchIconColor: colors['gray-500'],
            noDataTitleColor: 'text-gray-900',
            noDataDescriptionColor: 'text-gray-600',
            dividerBgColor: 'bg-gray-300',
            eyeIconColor: colors['gray-500'],
            eyeOffColor: colors['gray-300'],
            fieldLabelColor: 'text-gray-900'
         },
         pipelineStagesConfig: {
            headerTextColor: 'text-gray-900'
         }
      },
      autoGenerateCustomIdField: {
         labelColor: 'text-gray-700',
         descriptionTextColor: 'text-gray-600',
         infoIconColor: colors['gray-500']
      },
      allowedFileFormats: {
         labelColor: 'text-gray-500',
         valueColor: 'text-gray-800'
      },
      prefixSuffixOptions: {
         borderColor: 'border-gray-300',
         titleColor: 'text-gray-800',
         dividerBgColor: 'bg-gray-300'
      },
      formulaField: {
         formulaTitleColor: 'text-gray-700',
         infoCircleIconColor: colors['gray-500']
      }
   },
   dark: {}
}
